export default __webpack_public_path__ + "static/media/495.09ae1ee0.png";